"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("antd/lib/button/style");
var _button = _interopRequireDefault(require("antd/lib/button"));
require("antd/lib/switch/style");
var _switch = _interopRequireDefault(require("antd/lib/switch"));
var _react = _interopRequireWildcard(require("react"));
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _utils = require("../../../utils");
var _DataTable = require("../../../components/DataTable");
var _PatientGroupsList = require("../../PatientGroupsList");
var _SessionParticipationModal = _interopRequireDefault(require("./SessionParticipationModal"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var renderDate = function renderDate(fieldName) {
  return function (text, record) {
    return (0, _utils.formatDate)(record[fieldName], {
      timeFormat: 'h:mm A',
      withTime: true
    });
  };
};
var SessionList = function SessionList(_ref) {
  var data = _ref.data,
    _ref$definitions = _ref.definitions,
    definitions = _ref$definitions === void 0 ? {} : _ref$definitions,
    isEditable = _ref.isEditable,
    loading = _ref.loading;
  var _useState = (0, _react.useState)(null),
    _useState2 = _slicedToArray(_useState, 2),
    sessionId = _useState2[0],
    setSessionId = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showEmailModal = _useState4[0],
    setShowEmailModal = _useState4[1];
  var currentSession = data.find(function (session) {
    return session.id === sessionId;
  });
  var config = {
    columns: [{
      title: 'Status',
      dataIndex: 'archived',
      onFilter: (0, _utils.filter)('archived'),
      render: function render(text, record) {
        var onSessionArchive = definitions.onSessionArchive;
        var archived = record.archived,
          id = record.id,
          processing = record.processing,
          startAt = record.startAt,
          endAt = record.endAt;
        if (!onSessionArchive) {
          return archived ? 'Archived' : 'Active';
        }
        var onArchive = function onArchive(checked, event) {
          event.stopPropagation();
          definitions.onSessionArchive(id, {
            archived: !archived,
            startAt: startAt,
            endAt: endAt
          });
        };
        return /*#__PURE__*/_react.default.createElement(_switch.default, {
          checkedChildren: "Active",
          unCheckedChildren: "Archived",
          checked: !archived,
          loading: processing,
          onClick: onArchive
        });
      },
      width: '100px'
    }, {
      title: 'Moderator',
      dataIndex: 'moderatorId',
      render: function render(_, record) {
        return (0, _utils.personName)(record.moderatorInfo);
      }
    }, {
      title: 'Start',
      dataIndex: 'startAt',
      sorter: function sorter(a, b) {
        return (0, _momentTimezone.default)(a.startAt) - (0, _momentTimezone.default)(b.startAt);
      },
      defaultSortOrder: 'descend',
      render: renderDate('startAt'),
      width: '160px'
    }, {
      title: 'End',
      dataIndex: 'endAt',
      render: renderDate('endAt')
    }, {
      title: 'RSVPs',
      dataIndex: 'rsvpCount'
    }, {
      title: 'Attendees',
      key: 'attendeeCount',
      render: function render(session) {
        return (0, _PatientGroupsList.isAttendanceAvailable)(session) ? session.attendeeCount : 'N/A';
      }
    }, {
      title: 'Capacity',
      key: 'rsvpCapacity',
      render: function render(session) {
        return session.capacity;
      }
    }, {
      title: 'Actions',
      render: function render(_, record) {
        return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_button.default, {
          type: "link",
          onClick: function onClick() {
            return setSessionId(record.id);
          }
        }, "Show participation"), isEditable && /*#__PURE__*/_react.default.createElement(_button.default, {
          type: "link",
          onClick: function onClick() {
            return definitions.onEdit(record);
          }
        }, "Edit"));
      }
    }],
    rowKey: 'id'
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_SessionParticipationModal.default, {
    onClose: function onClose() {
      return setSessionId(null);
    },
    session: currentSession,
    showEmailModal: showEmailModal,
    toggleEmailModal: function toggleEmailModal() {
      return setShowEmailModal(!showEmailModal);
    }
  }), /*#__PURE__*/_react.default.createElement(_DataTable.DataTable, _extends({}, config, {
    dataSource: data,
    loading: loading,
    scroll: {
      x: false
    }
  })));
};
var _default = SessionList;
exports.default = _default;